var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 1,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "#112347"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1164 11.6322C11.2873 11.3492 12.2287 10.3202 12.9005 10.3513C13.1014 10.3679 13.2789 10.4894 13.4231 10.6303C13.7543 10.9537 14.7024 12.1769 14.7562 12.4343C14.8871 13.0656 14.1349 13.4295 14.3651 14.0658C14.952 15.502 15.9634 16.5132 17.4002 17.0996C18.0359 17.3298 18.3999 16.5776 19.0312 16.7091C19.288 16.7629 20.5118 17.7109 20.8353 18.0421C20.9756 18.1858 21.0977 18.3638 21.1143 18.5646C21.1393 19.2719 20.0464 20.2266 19.8334 20.3487C19.3308 20.7081 18.675 20.702 17.8756 20.3303C15.6449 19.4023 12.08 15.9047 11.1347 13.5898C10.773 12.7949 10.7481 12.1347 11.1164 11.6322Z",
    stroke: "#6C2AD2",
    strokeWidth: 0.81025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallPhone);
export default __webpack_public_path__ + "static/media/callPhone.76a5c339773ec4b28df5a7c448ee5ee5.svg";
export { ForwardRef as ReactComponent };